import { http } from './http'

export const ReviewsApi = {
  status: () => http.get('/api/reviews/my-status'),
  submit: (p: { content: string; publishAllowed: boolean }) => http.post('/api/reviews', p),
}
